import { ClientProps } from '@/types'
import { TYPO3 } from '@spot'

const client = async <T>({
  endpoint = true,
  ...props
}: ClientProps): Promise<T> => {
  // Construct the final path using the backend URL and language
  const path = endpoint
    ? `${TYPO3}/${props.lang}/${props.url}` // Use the dynamically passed backend URL
    : `${props.url}` // Fallback to the provided URL if endpoint is false

  try {
    const response = await fetch(path, props.options)
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw new Error('Failed to fetch data')
  }
}

export { client }
